import { NgModule } from '@angular/core';
import { AfterValueChangedDirective, NoWhitespaceValidatorDirective, NumericOnlyDirective, PasswordValidatorDirective, PhoneNumberValidatorDirective } from './directives';
import { CustomCurrencyPipe, SafePipe } from './pipes';

@NgModule({
	declarations: [
		SafePipe,
		CustomCurrencyPipe,
		AfterValueChangedDirective,
		NoWhitespaceValidatorDirective,
		NumericOnlyDirective,
		PasswordValidatorDirective,
		PhoneNumberValidatorDirective,
	],
	exports: [
		SafePipe,
		CustomCurrencyPipe,
		AfterValueChangedDirective,
		NoWhitespaceValidatorDirective,
		NumericOnlyDirective,
		PasswordValidatorDirective,
		PhoneNumberValidatorDirective,
	],
})
export class CommonLibModule {
}
